// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e9d67258","239":"d33f3794","488":"4ca699bc","732":"0050f0f3"}[chunkId] + ".chunk.js";
};